import React from 'react';

class ImpersonatingBanner extends React.Component {
	render() {
		return (
			<div className="impersonating-banner">
				You are currently viewing as {this.props.user.userInfo.name}. <a onClick={this.props.stopImpersonating}>Click here to stop</a>
			</div>
		);
	}
}

export default ImpersonatingBanner;


// WEBPACK FOOTER //
// ./source/components/ImpersonatingBanner.js